import client from '../httpClient';

// user: /users/:id ユーザー所属/権限履歴変更
const userHistoryApi = (modifyObj, id) => {
  const UPDATE_USER_HISTORY_URL = `/users/histories/${id}`;
  return client.put(UPDATE_USER_HISTORY_URL, JSON.stringify(modifyObj));
};

export default userHistoryApi;
